import { Reducer } from 'redux';
import {
  GET_REPORT,
  GET_REPORT_FAILURE,
  GET_REPORT_SUCCESS,
  GET_REPORTS,
  GET_REPORTS_FAILURE,
  GET_REPORTS_SUCCESS,
  ReportActionTypes,
  ReportState,
} from './types';

const initialState: ReportState = {
  isLoadingReport: false,
  isLoadingReports: false,
  report: null,
  reports: null,
};

const reportReducer: Reducer<ReportState, ReportActionTypes> = (
  state = initialState,
  action: ReportActionTypes,
): ReportState => {
  switch (action.type) {
    case GET_REPORT:
      return {
        ...state,
        isLoadingReport: true,
      };
    case GET_REPORT_SUCCESS:
      return {
        ...state,
        isLoadingReport: false,
        report: action.payload,
      };
    case GET_REPORT_FAILURE:
      return {
        ...state,
        isLoadingReport: false,
      };
    case GET_REPORTS:
      return { ...state, isLoadingReports: true };
    case GET_REPORTS_FAILURE:
      return { ...state, isLoadingReports: false };
    case GET_REPORTS_SUCCESS:
      return { ...state, isLoadingReports: false, reports: action.payload };
    default:
      return state;
  }
};

export default reportReducer;
